<template>
  <div class="dates-container">
    <div>
      <label for="startDate">Start date</label>
      <datepicker
        id="startDate"
        v-model="dateInit"
        name="start"
        class="datePicker"
        @selected="setStartDate"
      ></datepicker>
    </div>
    <div>
      <label for="endDate">End date</label>
      <datepicker
        id="endDate"
        v-model="dateEnd"
        name="end"
        class="datePicker"
        @selected="setEndDate"
      ></datepicker>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  props: {
    dateRange: {
      type: Object,
      required: false,
      default() {
        return {
          ini: new Date().toISOString(),
          end: new Date().toISOString()
        };
      }
    }
  },
  data() {
    return {
      dateInit: this.dateRange.ini,
      dateEnd: this.dateRange.end
    };
  },
  methods: {
    setStartDate(date) {
      this.dateRange.ini = date.toISOString();
      this.$emit("onDateChange", this.dateRange);
    },
    setEndDate(date) {
      this.dateRange.end = date.toISOString();
      this.$emit("onDateChange", this.dateRange);
    }
  }
};
</script>
<style scoped>
.dates-container {
  display: flex;
  margin-left: 50px;
  align-items: center;
}

.dates-container >>> input {
  font-family: "Montserrat", sans-serif;
}

.datePicker {
  font-size: 0.8rem !important;
  margin-left: 4px;
  margin-right: 4px;
}
</style>
